/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import dayjs from "dayjs";
import {Empty, Table, Tag} from "antd";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import styles from './CallPassTable.module.scss';
import {CallPass} from "../../../types/CallPass";
import {Baecha} from "../../../types/Baecha";
import {ScheduleType} from "../../../types/Type";
import {formatKorDate} from "../../../util/date";

const getScheduleStr = (schedule: ScheduleType) => {
	if (schedule === 'am') return '오전';
	if (schedule === 'pm') return '오후';
	if (schedule === 'ready') return '대기';
	if (schedule === 'day') return '하루';
	if (schedule === 'dayoff') return '휴무';
	if (schedule === 'absence') return '불참';
	return '';
};

const getLatLng = (wkbString: string) => {
	if (!wkbString || wkbString.length < 10) throw new Error("Invalid WKB string");
	const hexPairs = wkbString.match(/.{1,2}/g) ?? [];
	const bytes = new Uint8Array(hexPairs.map(byte => parseInt(byte, 16)));
	const view = new DataView(bytes.buffer);
	const isLittleEndian = view.getUint8(0) === 1;
	const offset = bytes.length - 16;
	if (offset < 0) throw new Error("WKB length is too short");
	const lon = view.getFloat64(offset, isLittleEndian);
	const lat = view.getFloat64(offset + 8, isLittleEndian);
	return { lon, lat };
};

interface CallPassTableProps {
	baechaData?: Baecha;
	callPassData?: CallPass[];
}

const CallPassTable = ({ baechaData, callPassData }: CallPassTableProps) => {
	if (!callPassData || callPassData.length === 0) return <Empty />;
	return (
		<Table
			bordered
			size='small'
			style={{ tableLayout: 'fixed', width: '100%' }}
			pagination={false}
			dataSource={callPassData.map((row, index) => ({...row, key: row.id}))}
			rowClassName={(record) => record.memberCarId === baechaData?.sujuMemberCarId
				? styles.selected
				: ''
			}
			columns={[
				{
					title: '콜/패스',
					dataIndex: 'callPassType',
					key: 'callPassType',
					width: 10,
					align: 'center',
					onCell: (record: CallPass) => ({
						onClick: (e) => {
							e.stopPropagation();
							if (record.latLng) {
								const { lon, lat } = getLatLng(record.latLng);
								window.open(`https://www.google.com/maps/place/${lat},${lon}`, '_blank');
							}
						},
						style: { cursor: record.latLng ? 'pointer' : '' },
					}),
					render: (value: any, record: CallPass, index: number) => value === 'call'
						? <Tag color="blue">콜</Tag>
						: <Tag color="red">패스</Tag>
				},
				{
					title: '콜/패스 일시',
					dataIndex: 'createDate',
					key: 'createDate',
					width: 40,
					align: 'center',
					render: (text: string) => (
						<div style={{ fontVariantNumeric: 'tabular-nums' }}>
							{formatKorDate(text)} {dayjs(text).format('HH:mm:ss.SSS')}
						</div>
					)
				},
				{
					title: (
						<>
							<div>차량</div>
							<div>순위</div>
						</>
					),
					dataIndex: 'carTypeRank',
					key: 'carTypeRank',
					width: 10,
					align: 'center',
				},
				{
					title: '차량',
					dataIndex: 'carType',
					key: 'carType',
					width: 10,
					align: 'center',
				},
				{
					title: (
						<>
							<div>차량</div>
							<div>번호</div>
						</>
					),
					dataIndex: 'carNumber',
					key: 'carNumber',
					width: 10,
					align: 'center',
				},
				{
					title: '멤버',
					dataIndex: 'memberNickname',
					key: 'memberNickname',
					width: 10,
					align: 'center',
				},
				{
					title: (
						<>
							<div>전월</div>
							<div>미수주</div>
						</>
					),
					dataIndex: 'isBenefit',
					key: 'isBenefit',
					width: 10,
					align: 'center',
					render: (value: any, record: CallPass, index: number) => value === true
						? <CheckOutlined style={{ color: 'green' }} />
						: <CloseOutlined />,
				},
				{
					title: (
						<>
							<div>당일</div>
							<div>수주 수</div>
						</>
					),
					dataIndex: 'duplicateSujuCount',
					key: 'duplicateSujuCount',
					width: 10,
					align: 'center',
				},
				{
					title: '일정',
					dataIndex: 'schedule',
					key: 'schedule',
					width: 10,
					align: 'center',
					render: (value: any, record: CallPass, index: number) => getScheduleStr(value),
				},
			]}
		/>
	);
};

export default CallPassTable;
